import { useAppSelector } from '../hooks'
import { ConnectionStatus } from '../stores/UserStore'

/**
 * Is the "Connection unstable…" banner currently on screen?
 *
 * Owned here rather than inside `ConnectionUnstableToast` because the SC-255 zoom notice has to
 * stack underneath that banner, and two components answering the same question separately are two
 * components that can disagree — which would show as an overlap or a floating gap.
 */
export function useConnectionBannerVisible(): boolean {
  const connectionStatus = useAppSelector((state) => state.user.connectionStatus)
  const roomJoined = useAppSelector((state) => state.room.roomJoined)

  return roomJoined && connectionStatus === ConnectionStatus.OFFLINE
}
